import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
};

export const getFabricList = createAsyncThunk(
  "get-fabric",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("fabric/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const createFabric = createAsyncThunk(
  "create-fabric",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("fabric", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const editFabric = createAsyncThunk(
  "edit-fabric",
  async (id, { dispatch }) => {
    try {
      const response = await axios.get(`fabric/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const updateFabric = createAsyncThunk(
  "update-fabric",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`/fabric/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const deleteFabric = createAsyncThunk(
  "delete-fabric",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`/fabric/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const fabricSlice = createSlice({
  name: "fabric",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getFabricList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getFabricList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.fabricList ?? [];
        state.perPage = action?.payload?.data?.data?.perPage ?? 1;
        state.total = action?.payload?.data?.data?.total ?? 0;
      })
      .addCase(getFabricList.rejected, (state, action) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      });
  },
});

export default fabricSlice.reducer;
